import * as React from 'react';
import { Avatar } from '@mui/material';

export default function PhotoBox({selectedUser}) {
  return (
    <React.Fragment>
      {selectedUser && (
        <Avatar
          src={selectedUser.photoUrl}
          sx={{ width: '100%', height: '100%' }}
        />
      )}
    </React.Fragment>
  );
}